export default __webpack_public_path__ + "static/media/Girdle of Vernant Fury.def70545.jpg";